import { COUNTRIES } from '@webstore-monorepo/shared/enums';

const originalFetch = global.fetch;

global.fetch = async (input: RequestInfo | URL, init?: RequestInit | undefined) => {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;

  // Check if this is a country data request from the picker
  try {
    const parsedUrl = new URL(url);
    const allowedHosts = ['xcarpentier.github.io', 'restcountries.com', 'restcountries.eu'];

    if (
      allowedHosts.includes(parsedUrl.host) &&
      (parsedUrl.pathname.startsWith('/react-native-country-picker-modal/countries/') ||
        parsedUrl.pathname === '/v2/all' ||
        parsedUrl.pathname === '/rest/v2/all')
    ) {
      // Return our constant data
      return new Response(JSON.stringify(COUNTRIES), {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
  } catch (e) {
    console.error('Invalid URL:', url, e);
  }

  // For all other requests, use the original fetch
  return originalFetch(input, init);
};

export const setupCountryInterceptor = () => {
  if (process?.env?.NODE_ENV === 'development') {
    console.log('Country data interceptor initialized');
  }
};
